<div>
     <section id="main"
              class="bg-light">
          <div id="dashboardContainer"
               class="container">
               <div class="overlay"
                    *ngIf="isLoading">
                    <h1 class="heading"
                        [innerHtml]="'Loading' | translator: 'base'">Loading...</h1>
                    <img alt="Loading" />
               </div>
               <div class="overlay"
                    *ngIf="isSaving">
                    <h1 class="heading"
                        [innerHtml]="'SavingLoaderText' | translator: 'base'">Saving...</h1>
                    <img alt="Saving" />
               </div>
               <h1 [innerHtml]="'DriverDashboardHeader' | translator: 'driver'">Driver Dashboard
               </h1>
               <div class="row">
                    <div class="col-12">
                         <button class="btn btn-primary btn-strong mb-3 me-2"
                                 [routerLink]="'/driver/1/reorder'"
                                 (click)="scrollToTop()"
                                 [title]="'RequestRecords' | translator: 'driver'"
                                 id="requestRecord"
                                 name="requestRecord"
                                 [innerHtml]="'RequestRecords' | translator: 'driver'">
                              REQUEST MY RECORDS
                         </button>
                         <button *ngIf="!isEnrolled"
                                 class="btn btn-primary mb-3 me-2"
                                 (click)="navigateToMonitoring()"
                                 [title]="'psp_monitoring' | translator: 'driver'"
                                 id="psp_monitoring"
                                 name="psp_monitoring">
                              <span [innerHtml]="'psp_monitoring' | translator: 'driver'">
                                   PSP Monitoring
                              </span>
                         </button>
                         <button *ngIf="!isEnrolled"
                                 class="btn btn-outline-primary mb-3"
                                 (click)="showMonitoringInfoModal()"
                                 [title]="'WhatIsMonitoring' | translator: 'driver'"
                                 id="showMonitoringInfo"
                                 name="showMonitoringInfo">
                              <span [innerHtml]="'WhatIsMonitoring' | translator: 'driver'">
                                   What is PSP monitoring?
                              </span>
                         </button>
                         <p [innerHtml]="'DashboardExplanation1' | translator: 'driver'">
                              All requested PSP records for your account are displayed below. You may save or print each
                              record for 5 days (120
                              hours) from the time of record request.
                         </p>
                         <p>
                              <span [innerHtml]="'DashboardExplanation2' | translator: 'driver'">
                                   After 5 days, the record is shown below
                                   only for historical purposes but may not be accessed. If you require access, you may
                              </span>
                              <button class="btn btn-link"
                                      [routerLink]="'/driver/3'"
                                      (click)="scrollToTop()"
                                      [title]="'DashboardExplanation3' | translator: 'driver'"
                                      [innerHtml]="'DashboardExplanation3' | translator: 'driver'"
                                      id="requestRecordLink"
                                      name="requestRecordLink">
                                   request an up-to-date record.
                              </button>
                         </p>

                         <p [innerHtml]="'DashboardMVR' | translator: 'driver'">
                              To request a motor vehicle record (MVR) for a specific state, the MVR by State link found in the top navigation will take you to a list of the motor vehicle record request websites by state.
                         </p>
                         <div class="row justify-content-sm-center no-gutters">
                              <div class="col-12 text-center mb-3"
                                   *ngIf="!isEnrolled">
                                   <button class="btn btn-outline-primary btn-sm"
                                           (click)="navigateToMonitoring()"
                                           [title]="'GetAnAlert' | translator: 'driver'"
                                           id="getAnAlert"
                                           name="getAnAlert"
                                           [innerHtml]="'GetAnAlert' | translator: 'driver'">
                                        Get an alert when your record changes
                                   </button>
                              </div>
                              <div class="col-12">
                                   <div class="card shadow-sm rounded-0 border-0 mb-3">
                                        <div class="card-body">
                                             <app-driver-dashboard-grid></app-driver-dashboard-grid>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>

                    <!-- Keep -->
                    <ng-template #WhatIsMonitoringModal let-modal>
                         <div class="modal-header">
                              <h3 
                                   id="whatIsMonitoringModalTitle" 
                                   class="modal-title"
                                   [innerHtml]="'WhatIsMonitoring' | translator: 'driver'">
                                   What is PSP Monitoring?
                              </h3>
                         </div>
                         <div class="modal-body">
                              <p [innerHtml]="'MonitoringInfo1' | translator: 'driver'">
                                   PSP monitoring is a service that watches your PSP record. You will receive a notification whenever your record is updated.
                              </p>
                         </div>
                         <div class="modal-footer">
                              <button class="btn btn-outline-primary"
                                      [title]="'Close' | translator: 'base'"
                                      [innerHtml]="'Close' | translator: 'base'"
                                      name="okay"
                                      (click)="closeModal()">
                                   Close
                              </button>
                         </div>
                    </ng-template>

                    <ng-template #ErrorSavingModal let-modal>
                         <div class="modal-header">
                              <h3 
                                   id="errorSavingModalTitle" 
                                   class="modal-title"
                                   [innerHtml]="'Problem' | translator: 'driver'">
                                   A problem has occurred
                              </h3>
                         </div>
                         <div class="modal-body">
                              <p [innerHtml]="'WasError' | translator: 'driver'">
                                   Please contact the PSP Customer Support Team at 
                                   <a alt="call customer service" href="tel:8776429499" name="1-877-642-9499">1-877-642-9499</a>. 
                                   The PSP team is available by phone Monday through Thursday from 8 AM to 6
                                   PM ET, and on Friday from 8 AM to 5 PM ET.
                              </p>
                         </div>
                         <div class="modal-footer">
                              <button class="btn btn-outline-primary"
                                      [title]="'OK' | translator: 'base'"
                                      [innerHtml]="'OK' | translator: 'base'"
                                      name="okay"
                                      (click)="closeModal()">
                                   OK
                              </button>
                         </div>
                    </ng-template>
               </div>
               <div class="row justify-content-sm-center no-gutters mb-3">
                    <div class="col-12 col-md-6 mb-3 mb-md-0"><app-dashboardnews class="h-100" /></div>
                    <div class="col-12 col-md-6"><app-dashboardsupport class="h-100" /></div>
               </div>
          </div>
     </section>
</div>